import React from "react";
import { Box, Typography } from "@mui/material";
import { MERCHANT_LEGAL } from "../config/merchantLegalConfig";

const linkSx = { color: "inherit", textDecoration: "underline" };

/** Company contact block for footer, checkout, and policy pages. */
const MerchantLegalNotice = ({ variant = "body2", sx = {}, headingVariant = "subtitle2" }) => (
  <Box sx={{ lineHeight: 1.65, ...sx }}>
    <Typography variant={headingVariant} component="div" sx={{ fontWeight: 700, mb: 0.75 }}>
      {MERCHANT_LEGAL.brandName} — customer support
    </Typography>
    <Typography variant={variant} component="div">
      <strong>Email:</strong>{" "}
      <Typography
        component="a"
        href={`mailto:${MERCHANT_LEGAL.supportEmail}`}
        variant={variant}
        sx={linkSx}
      >
        {MERCHANT_LEGAL.supportEmail}
      </Typography>
      <br />
      <strong>Phone:</strong>{" "}
      <Typography
        component="a"
        href={`tel:${MERCHANT_LEGAL.supportPhoneTel}`}
        variant={variant}
        sx={linkSx}
      >
        {MERCHANT_LEGAL.supportPhone}
      </Typography>
      <br />
      <strong>Hours:</strong> Mon–Sat, 9:00 AM – 6:00 PM IST
      <br />
      <strong>GSTIN:</strong> {MERCHANT_LEGAL.gstin}
    </Typography>
  </Box>
);

export default MerchantLegalNotice;
